<script setup lang="ts">
import { processError } from "~/lib/utils/errors";

const omniaSdk = useOmniaSdk();

const { data: areas } = useAsyncData("all-areas", async () => {
  try {
    return await omniaSdk.v1.areas.list({ pagination: "none" });
  } catch (error) {
    processError(error);
  }
});

const areasFilter = defineModel<string[]>();
</script>

<template>
  <FrontCheckboxCard
    name="area"
    title="Filtra per area"
    v-if="areas?.data.length"
    base-key="scadenze_type"
    :options="areas?.data.map((area) => ({ label: area.title, value: area.slug }))"
    v-model="areasFilter"
    v-bind="$props"
  />
</template>
